import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const useShapeLibStore = create(persist(
  (set, get) => ({
    favorites: [],
    searchQuery: '',
    activeCategory: 'all',

    toggleFavorite: (id) => set(s => ({
      favorites: s.favorites.includes(id)
        ? s.favorites.filter(f => f !== id)
        : [...s.favorites, id],
    })),

    isFavorite: (id) => get().favorites.includes(id),

    setSearch: (q) => set({ searchQuery: q }),
    setCategory: (cat) => set({ activeCategory: cat }),
  }),
  {
    name: 'labelforge-shape-favorites',
    partialize: (state) => ({ favorites: state.favorites }),
  }
));
